module.exports = __webpack_public_path__ + "img/fb09.321a5869.jpg";